import pageActions from '../page/actions';
import groupActions from '../groups/actions';
import dialogActions from '../dialogs/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
    case pageActions.NEXT_FAILED:
    case groupActions.NEXT_FAILED:
    case dialogActions.SEND_CODE_SUCCESS:
      return (action.payload.data.meta && action.payload.data.meta.configs) || state;
    default:
      return state;
  }
};
